// Auto-generated by @semilayer/codegen — do not edit

import type { SearchParams, SearchResponse, SimilarParams, SimilarResponse, QueryParams, QueryResponse, CountParams, CountResponse, StreamSearchParams, SearchResult, StreamQueryParams, SubscribeParams, StreamEvent, FeedRequest, FeedPage, FeedTickEvent, FeedExplanation, FeedContext, AnalyzeResult, AnalyzeRowsPage, AnalyzeListResponse, AnalyzeExplanation, AnalyzeStreamEvent, AnalyzeCache } from '@semilayer/client'
import { BeamClient } from '@semilayer/client'
import type { TicksMetadata, WildFactsMetadata, RemovalTechniquesMetadata, StatesMetadata, CountiesMetadata, DiseasesMetadata, TickStateMetadata, TickCountyMetadata, DiseaseCountyYearMetadata, PathogensMetadata, PathogenCountyMetadata, DiseaseMonthMetadata, TickDiseasesMetadata, TickPathogensMetadata, DiseasePathogensMetadata, TickRemovalTechniquesMetadata, WildFactTicksMetadata, WildFactDiseasesMetadata, WildFactRemovalTechniquesMetadata } from './metadata.js'

export class TicksLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TicksMetadata = keyof TicksMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TicksMetadata, K>>> {
    return this.client.query<Pick<TicksMetadata, K>>('ticks', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('ticks', params)
  }

  async search<K extends keyof TicksMetadata = keyof TicksMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TicksMetadata, K>>> {
    return this.client.search<Pick<TicksMetadata, K>>('ticks', params as SearchParams)
  }

  async searchKeyword<K extends keyof TicksMetadata = keyof TicksMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TicksMetadata, K>>> {
    return this.client.search<Pick<TicksMetadata, K>>('ticks', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof TicksMetadata = keyof TicksMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TicksMetadata, K>>> {
    return this.client.search<Pick<TicksMetadata, K>>('ticks', { ...params, mode: 'hybrid' } as SearchParams)
  }

  async similar<K extends keyof TicksMetadata = keyof TicksMetadata>(
    params: Omit<SimilarParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SimilarResponse<Pick<TicksMetadata, K>>> {
    return this.client.similar<Pick<TicksMetadata, K>>('ticks', params as SimilarParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<TicksMetadata>> =>
      this.client.stream.search<TicksMetadata>('ticks', params),
    query: (params: StreamQueryParams): AsyncIterable<TicksMetadata> =>
      this.client.stream.query<TicksMetadata>('ticks', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TicksMetadata>> =>
      this.client.stream.subscribe<TicksMetadata>('ticks', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TicksMetadata> {
    return this.client.observe<TicksMetadata>('ticks', recordId)
  }

  /** Named feeds. `beam.ticks.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    relatedTo: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<TicksMetadata>> => this.client.feed<TicksMetadata>('ticks', 'relatedTo', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<TicksMetadata>> => this.client.feedNext<TicksMetadata>('ticks', 'relatedTo', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('ticks', 'relatedTo', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<TicksMetadata>> => this.client.explainFeed<TicksMetadata>('ticks', 'relatedTo', params),
      },
    ),
  }
}

export class WildFactsLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof WildFactsMetadata = keyof WildFactsMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<WildFactsMetadata, K>>> {
    return this.client.query<Pick<WildFactsMetadata, K>>('wildFacts', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('wildFacts', params)
  }

  async search<K extends keyof WildFactsMetadata = keyof WildFactsMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<WildFactsMetadata, K>>> {
    return this.client.search<Pick<WildFactsMetadata, K>>('wildFacts', params as SearchParams)
  }

  async searchKeyword<K extends keyof WildFactsMetadata = keyof WildFactsMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<WildFactsMetadata, K>>> {
    return this.client.search<Pick<WildFactsMetadata, K>>('wildFacts', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof WildFactsMetadata = keyof WildFactsMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<WildFactsMetadata, K>>> {
    return this.client.search<Pick<WildFactsMetadata, K>>('wildFacts', { ...params, mode: 'hybrid' } as SearchParams)
  }

  async similar<K extends keyof WildFactsMetadata = keyof WildFactsMetadata>(
    params: Omit<SimilarParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SimilarResponse<Pick<WildFactsMetadata, K>>> {
    return this.client.similar<Pick<WildFactsMetadata, K>>('wildFacts', params as SimilarParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<WildFactsMetadata>> =>
      this.client.stream.search<WildFactsMetadata>('wildFacts', params),
    query: (params: StreamQueryParams): AsyncIterable<WildFactsMetadata> =>
      this.client.stream.query<WildFactsMetadata>('wildFacts', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<WildFactsMetadata>> =>
      this.client.stream.subscribe<WildFactsMetadata>('wildFacts', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<WildFactsMetadata> {
    return this.client.observe<WildFactsMetadata>('wildFacts', recordId)
  }

  /** Named feeds. `beam.wildFacts.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    latest: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<WildFactsMetadata>> => this.client.feed<WildFactsMetadata>('wildFacts', 'latest', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<WildFactsMetadata>> => this.client.feedNext<WildFactsMetadata>('wildFacts', 'latest', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('wildFacts', 'latest', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<WildFactsMetadata>> => this.client.explainFeed<WildFactsMetadata>('wildFacts', 'latest', params),
      },
    ),
    relatedTo: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<WildFactsMetadata>> => this.client.feed<WildFactsMetadata>('wildFacts', 'relatedTo', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<WildFactsMetadata>> => this.client.feedNext<WildFactsMetadata>('wildFacts', 'relatedTo', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('wildFacts', 'relatedTo', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<WildFactsMetadata>> => this.client.explainFeed<WildFactsMetadata>('wildFacts', 'relatedTo', params),
      },
    ),
  }
}

export class RemovalTechniquesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof RemovalTechniquesMetadata = keyof RemovalTechniquesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<RemovalTechniquesMetadata, K>>> {
    return this.client.query<Pick<RemovalTechniquesMetadata, K>>('removalTechniques', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('removalTechniques', params)
  }

  async search<K extends keyof RemovalTechniquesMetadata = keyof RemovalTechniquesMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<RemovalTechniquesMetadata, K>>> {
    return this.client.search<Pick<RemovalTechniquesMetadata, K>>('removalTechniques', params as SearchParams)
  }

  async searchKeyword<K extends keyof RemovalTechniquesMetadata = keyof RemovalTechniquesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<RemovalTechniquesMetadata, K>>> {
    return this.client.search<Pick<RemovalTechniquesMetadata, K>>('removalTechniques', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof RemovalTechniquesMetadata = keyof RemovalTechniquesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<RemovalTechniquesMetadata, K>>> {
    return this.client.search<Pick<RemovalTechniquesMetadata, K>>('removalTechniques', { ...params, mode: 'hybrid' } as SearchParams)
  }

  async similar<K extends keyof RemovalTechniquesMetadata = keyof RemovalTechniquesMetadata>(
    params: Omit<SimilarParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SimilarResponse<Pick<RemovalTechniquesMetadata, K>>> {
    return this.client.similar<Pick<RemovalTechniquesMetadata, K>>('removalTechniques', params as SimilarParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<RemovalTechniquesMetadata>> =>
      this.client.stream.search<RemovalTechniquesMetadata>('removalTechniques', params),
    query: (params: StreamQueryParams): AsyncIterable<RemovalTechniquesMetadata> =>
      this.client.stream.query<RemovalTechniquesMetadata>('removalTechniques', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<RemovalTechniquesMetadata>> =>
      this.client.stream.subscribe<RemovalTechniquesMetadata>('removalTechniques', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<RemovalTechniquesMetadata> {
    return this.client.observe<RemovalTechniquesMetadata>('removalTechniques', recordId)
  }

  /** Named feeds. `beam.removalTechniques.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    latest: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<RemovalTechniquesMetadata>> => this.client.feed<RemovalTechniquesMetadata>('removalTechniques', 'latest', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<RemovalTechniquesMetadata>> => this.client.feedNext<RemovalTechniquesMetadata>('removalTechniques', 'latest', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('removalTechniques', 'latest', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<RemovalTechniquesMetadata>> => this.client.explainFeed<RemovalTechniquesMetadata>('removalTechniques', 'latest', params),
      },
    ),
    relatedTo: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<RemovalTechniquesMetadata>> => this.client.feed<RemovalTechniquesMetadata>('removalTechniques', 'relatedTo', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<RemovalTechniquesMetadata>> => this.client.feedNext<RemovalTechniquesMetadata>('removalTechniques', 'relatedTo', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('removalTechniques', 'relatedTo', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<RemovalTechniquesMetadata>> => this.client.explainFeed<RemovalTechniquesMetadata>('removalTechniques', 'relatedTo', params),
      },
    ),
  }
}

export class StatesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof StatesMetadata = keyof StatesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<StatesMetadata, K>>> {
    return this.client.query<Pick<StatesMetadata, K>>('states', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('states', params)
  }

  async search<K extends keyof StatesMetadata = keyof StatesMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<StatesMetadata, K>>> {
    return this.client.search<Pick<StatesMetadata, K>>('states', params as SearchParams)
  }

  async searchKeyword<K extends keyof StatesMetadata = keyof StatesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<StatesMetadata, K>>> {
    return this.client.search<Pick<StatesMetadata, K>>('states', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof StatesMetadata = keyof StatesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<StatesMetadata, K>>> {
    return this.client.search<Pick<StatesMetadata, K>>('states', { ...params, mode: 'hybrid' } as SearchParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<StatesMetadata>> =>
      this.client.stream.search<StatesMetadata>('states', params),
    query: (params: StreamQueryParams): AsyncIterable<StatesMetadata> =>
      this.client.stream.query<StatesMetadata>('states', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<StatesMetadata>> =>
      this.client.stream.subscribe<StatesMetadata>('states', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<StatesMetadata> {
    return this.client.observe<StatesMetadata>('states', recordId)
  }
}

export class CountiesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof CountiesMetadata = keyof CountiesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<CountiesMetadata, K>>> {
    return this.client.query<Pick<CountiesMetadata, K>>('counties', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('counties', params)
  }

  async search<K extends keyof CountiesMetadata = keyof CountiesMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<CountiesMetadata, K>>> {
    return this.client.search<Pick<CountiesMetadata, K>>('counties', params as SearchParams)
  }

  async searchKeyword<K extends keyof CountiesMetadata = keyof CountiesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<CountiesMetadata, K>>> {
    return this.client.search<Pick<CountiesMetadata, K>>('counties', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof CountiesMetadata = keyof CountiesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<CountiesMetadata, K>>> {
    return this.client.search<Pick<CountiesMetadata, K>>('counties', { ...params, mode: 'hybrid' } as SearchParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<CountiesMetadata>> =>
      this.client.stream.search<CountiesMetadata>('counties', params),
    query: (params: StreamQueryParams): AsyncIterable<CountiesMetadata> =>
      this.client.stream.query<CountiesMetadata>('counties', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<CountiesMetadata>> =>
      this.client.stream.subscribe<CountiesMetadata>('counties', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<CountiesMetadata> {
    return this.client.observe<CountiesMetadata>('counties', recordId)
  }

  /** Named feeds. `beam.counties.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    byDiseaseLoad: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<CountiesMetadata>> => this.client.feed<CountiesMetadata>('counties', 'byDiseaseLoad', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<CountiesMetadata>> => this.client.feedNext<CountiesMetadata>('counties', 'byDiseaseLoad', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('counties', 'byDiseaseLoad', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<CountiesMetadata>> => this.client.explainFeed<CountiesMetadata>('counties', 'byDiseaseLoad', params),
      },
    ),
  }
}

export class DiseasesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof DiseasesMetadata = keyof DiseasesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<DiseasesMetadata, K>>> {
    return this.client.query<Pick<DiseasesMetadata, K>>('diseases', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('diseases', params)
  }

  async search<K extends keyof DiseasesMetadata = keyof DiseasesMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<DiseasesMetadata, K>>> {
    return this.client.search<Pick<DiseasesMetadata, K>>('diseases', params as SearchParams)
  }

  async searchKeyword<K extends keyof DiseasesMetadata = keyof DiseasesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<DiseasesMetadata, K>>> {
    return this.client.search<Pick<DiseasesMetadata, K>>('diseases', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof DiseasesMetadata = keyof DiseasesMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<DiseasesMetadata, K>>> {
    return this.client.search<Pick<DiseasesMetadata, K>>('diseases', { ...params, mode: 'hybrid' } as SearchParams)
  }

  async similar<K extends keyof DiseasesMetadata = keyof DiseasesMetadata>(
    params: Omit<SimilarParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SimilarResponse<Pick<DiseasesMetadata, K>>> {
    return this.client.similar<Pick<DiseasesMetadata, K>>('diseases', params as SimilarParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<DiseasesMetadata>> =>
      this.client.stream.search<DiseasesMetadata>('diseases', params),
    query: (params: StreamQueryParams): AsyncIterable<DiseasesMetadata> =>
      this.client.stream.query<DiseasesMetadata>('diseases', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<DiseasesMetadata>> =>
      this.client.stream.subscribe<DiseasesMetadata>('diseases', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<DiseasesMetadata> {
    return this.client.observe<DiseasesMetadata>('diseases', recordId)
  }

  /** Named feeds. `beam.diseases.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    relatedTo: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<DiseasesMetadata>> => this.client.feed<DiseasesMetadata>('diseases', 'relatedTo', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<DiseasesMetadata>> => this.client.feedNext<DiseasesMetadata>('diseases', 'relatedTo', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('diseases', 'relatedTo', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<DiseasesMetadata>> => this.client.explainFeed<DiseasesMetadata>('diseases', 'relatedTo', params),
      },
    ),
    trending: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<DiseasesMetadata>> => this.client.feed<DiseasesMetadata>('diseases', 'trending', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<DiseasesMetadata>> => this.client.feedNext<DiseasesMetadata>('diseases', 'trending', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('diseases', 'trending', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<DiseasesMetadata>> => this.client.explainFeed<DiseasesMetadata>('diseases', 'trending', params),
      },
    ),
  }
}

export class TickStateLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TickStateMetadata = keyof TickStateMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TickStateMetadata, K>>> {
    return this.client.query<Pick<TickStateMetadata, K>>('tickState', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('tickState', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<TickStateMetadata> =>
      this.client.stream.query<TickStateMetadata>('tickState', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TickStateMetadata>> =>
      this.client.stream.subscribe<TickStateMetadata>('tickState', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TickStateMetadata> {
    return this.client.observe<TickStateMetadata>('tickState', recordId)
  }
}

export class TickCountyLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TickCountyMetadata = keyof TickCountyMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TickCountyMetadata, K>>> {
    return this.client.query<Pick<TickCountyMetadata, K>>('tickCounty', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('tickCounty', params)
  }

  async search<K extends keyof TickCountyMetadata = keyof TickCountyMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TickCountyMetadata, K>>> {
    return this.client.search<Pick<TickCountyMetadata, K>>('tickCounty', params as SearchParams)
  }

  async searchKeyword<K extends keyof TickCountyMetadata = keyof TickCountyMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TickCountyMetadata, K>>> {
    return this.client.search<Pick<TickCountyMetadata, K>>('tickCounty', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof TickCountyMetadata = keyof TickCountyMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<TickCountyMetadata, K>>> {
    return this.client.search<Pick<TickCountyMetadata, K>>('tickCounty', { ...params, mode: 'hybrid' } as SearchParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<TickCountyMetadata>> =>
      this.client.stream.search<TickCountyMetadata>('tickCounty', params),
    query: (params: StreamQueryParams): AsyncIterable<TickCountyMetadata> =>
      this.client.stream.query<TickCountyMetadata>('tickCounty', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TickCountyMetadata>> =>
      this.client.stream.subscribe<TickCountyMetadata>('tickCounty', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TickCountyMetadata> {
    return this.client.observe<TickCountyMetadata>('tickCounty', recordId)
  }

  /** Named feeds. `beam.tickCounty.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    latest: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<TickCountyMetadata>> => this.client.feed<TickCountyMetadata>('tickCounty', 'latest', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<TickCountyMetadata>> => this.client.feedNext<TickCountyMetadata>('tickCounty', 'latest', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('tickCounty', 'latest', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<TickCountyMetadata>> => this.client.explainFeed<TickCountyMetadata>('tickCounty', 'latest', params),
      },
    ),
    recentlyEstablished: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<TickCountyMetadata>> => this.client.feed<TickCountyMetadata>('tickCounty', 'recentlyEstablished', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<TickCountyMetadata>> => this.client.feedNext<TickCountyMetadata>('tickCounty', 'recentlyEstablished', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('tickCounty', 'recentlyEstablished', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<TickCountyMetadata>> => this.client.explainFeed<TickCountyMetadata>('tickCounty', 'recentlyEstablished', params),
      },
    ),
  }

  /** Named analyses. `beam.tickCounty.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('tickCounty'),
    establishedRange: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "counties": number }>> => this.client.analyze<{ "tickId": number }, { "counties": number }>('tickCounty', 'establishedRange', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "counties": number }>> => this.client.analyzeNext<{ "tickId": number }, { "counties": number }>('tickCounty', 'establishedRange', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "tickId": number }, { "counties": number }>> => this.client.subscribeAnalyze<{ "tickId": number }, { "counties": number }>('tickCounty', 'establishedRange', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickCounty', 'establishedRange', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickCounty', 'establishedRange', opts),
      },
    ),
    establishedByState: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number; "stateFips": unknown }, { "counties": number }>> => this.client.analyze<{ "tickId": number; "stateFips": unknown }, { "counties": number }>('tickCounty', 'establishedByState', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number; "stateFips": unknown }, { "counties": number }>> => this.client.analyzeNext<{ "tickId": number; "stateFips": unknown }, { "counties": number }>('tickCounty', 'establishedByState', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "tickId": number; "stateFips": unknown }, { "counties": number }>> => this.client.subscribeAnalyze<{ "tickId": number; "stateFips": unknown }, { "counties": number }>('tickCounty', 'establishedByState', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickCounty', 'establishedByState', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickCounty', 'establishedByState', opts),
      },
    ),
    spreadOverTime: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number; "year": number }, { "counties": number }>> => this.client.analyze<{ "tickId": number; "year": number }, { "counties": number }>('tickCounty', 'spreadOverTime', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number; "year": number }, { "counties": number }>> => this.client.analyzeNext<{ "tickId": number; "year": number }, { "counties": number }>('tickCounty', 'spreadOverTime', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "tickId": number; "year": number }, { "counties": number }>> => this.client.subscribeAnalyze<{ "tickId": number; "year": number }, { "counties": number }>('tickCounty', 'spreadOverTime', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickCounty', 'spreadOverTime', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickCounty', 'spreadOverTime', opts),
      },
    ),
  }
}

export class DiseaseCountyYearLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof DiseaseCountyYearMetadata = keyof DiseaseCountyYearMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<DiseaseCountyYearMetadata, K>>> {
    return this.client.query<Pick<DiseaseCountyYearMetadata, K>>('diseaseCountyYear', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('diseaseCountyYear', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<DiseaseCountyYearMetadata> =>
      this.client.stream.query<DiseaseCountyYearMetadata>('diseaseCountyYear', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<DiseaseCountyYearMetadata>> =>
      this.client.stream.subscribe<DiseaseCountyYearMetadata>('diseaseCountyYear', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<DiseaseCountyYearMetadata> {
    return this.client.observe<DiseaseCountyYearMetadata>('diseaseCountyYear', recordId)
  }

  /** Named feeds. `beam.diseaseCountyYear.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    latest: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<DiseaseCountyYearMetadata>> => this.client.feed<DiseaseCountyYearMetadata>('diseaseCountyYear', 'latest', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<DiseaseCountyYearMetadata>> => this.client.feedNext<DiseaseCountyYearMetadata>('diseaseCountyYear', 'latest', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('diseaseCountyYear', 'latest', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<DiseaseCountyYearMetadata>> => this.client.explainFeed<DiseaseCountyYearMetadata>('diseaseCountyYear', 'latest', params),
      },
    ),
  }

  /** Named analyses. `beam.diseaseCountyYear.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('diseaseCountyYear'),
    casesByYear: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>> => this.client.analyze<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>('diseaseCountyYear', 'casesByYear', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>> => this.client.analyzeNext<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>('diseaseCountyYear', 'casesByYear', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>> => this.client.subscribeAnalyze<{ "year": number; "diseaseId": number }, { "total": number; "counties": number }>('diseaseCountyYear', 'casesByYear', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseaseCountyYear', 'casesByYear', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseaseCountyYear', 'casesByYear', opts),
      },
    ),
    casesByState: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>> => this.client.analyze<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>('diseaseCountyYear', 'casesByState', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>> => this.client.analyzeNext<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>('diseaseCountyYear', 'casesByState', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>> => this.client.subscribeAnalyze<{ "diseaseId": number; "stateFips": unknown }, { "total": number; "counties": number; "yearsCovered": number }>('diseaseCountyYear', 'casesByState', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseaseCountyYear', 'casesByState', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseaseCountyYear', 'casesByState', opts),
      },
    ),
    countyHotspots: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>> => this.client.analyze<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>('diseaseCountyYear', 'countyHotspots', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>> => this.client.analyzeNext<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>('diseaseCountyYear', 'countyHotspots', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>> => this.client.subscribeAnalyze<{ "countyName": unknown; "countyFips": string; "stateFips": unknown }, { "total": number; "mostRecentYear": number; "diseases": number }>('diseaseCountyYear', 'countyHotspots', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseaseCountyYear', 'countyHotspots', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseaseCountyYear', 'countyHotspots', opts),
      },
    ),
    densityByH3: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>> => this.client.analyze<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>('diseaseCountyYear', 'densityByH3', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>> => this.client.analyzeNext<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>('diseaseCountyYear', 'densityByH3', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>> => this.client.subscribeAnalyze<{ "h3Cell": string }, { "total": number; "counties": number; "diseases": number }>('diseaseCountyYear', 'densityByH3', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseaseCountyYear', 'densityByH3', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseaseCountyYear', 'densityByH3', opts),
      },
    ),
  }
}

export class PathogensLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof PathogensMetadata = keyof PathogensMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<PathogensMetadata, K>>> {
    return this.client.query<Pick<PathogensMetadata, K>>('pathogens', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('pathogens', params)
  }

  async search<K extends keyof PathogensMetadata = keyof PathogensMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogensMetadata, K>>> {
    return this.client.search<Pick<PathogensMetadata, K>>('pathogens', params as SearchParams)
  }

  async searchKeyword<K extends keyof PathogensMetadata = keyof PathogensMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogensMetadata, K>>> {
    return this.client.search<Pick<PathogensMetadata, K>>('pathogens', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof PathogensMetadata = keyof PathogensMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogensMetadata, K>>> {
    return this.client.search<Pick<PathogensMetadata, K>>('pathogens', { ...params, mode: 'hybrid' } as SearchParams)
  }

  async similar<K extends keyof PathogensMetadata = keyof PathogensMetadata>(
    params: Omit<SimilarParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SimilarResponse<Pick<PathogensMetadata, K>>> {
    return this.client.similar<Pick<PathogensMetadata, K>>('pathogens', params as SimilarParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<PathogensMetadata>> =>
      this.client.stream.search<PathogensMetadata>('pathogens', params),
    query: (params: StreamQueryParams): AsyncIterable<PathogensMetadata> =>
      this.client.stream.query<PathogensMetadata>('pathogens', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<PathogensMetadata>> =>
      this.client.stream.subscribe<PathogensMetadata>('pathogens', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<PathogensMetadata> {
    return this.client.observe<PathogensMetadata>('pathogens', recordId)
  }

  /** Named feeds. `beam.pathogens.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    relatedTo: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<PathogensMetadata>> => this.client.feed<PathogensMetadata>('pathogens', 'relatedTo', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<PathogensMetadata>> => this.client.feedNext<PathogensMetadata>('pathogens', 'relatedTo', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('pathogens', 'relatedTo', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<PathogensMetadata>> => this.client.explainFeed<PathogensMetadata>('pathogens', 'relatedTo', params),
      },
    ),
  }
}

export class PathogenCountyLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof PathogenCountyMetadata = keyof PathogenCountyMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<PathogenCountyMetadata, K>>> {
    return this.client.query<Pick<PathogenCountyMetadata, K>>('pathogenCounty', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('pathogenCounty', params)
  }

  async search<K extends keyof PathogenCountyMetadata = keyof PathogenCountyMetadata>(
    params: Omit<SearchParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogenCountyMetadata, K>>> {
    return this.client.search<Pick<PathogenCountyMetadata, K>>('pathogenCounty', params as SearchParams)
  }

  async searchKeyword<K extends keyof PathogenCountyMetadata = keyof PathogenCountyMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogenCountyMetadata, K>>> {
    return this.client.search<Pick<PathogenCountyMetadata, K>>('pathogenCounty', { ...params, mode: 'keyword' } as SearchParams)
  }

  async searchHybrid<K extends keyof PathogenCountyMetadata = keyof PathogenCountyMetadata>(
    params: Omit<SearchParams, 'fields' | 'mode'> & { fields?: readonly K[] },
  ): Promise<SearchResponse<Pick<PathogenCountyMetadata, K>>> {
    return this.client.search<Pick<PathogenCountyMetadata, K>>('pathogenCounty', { ...params, mode: 'hybrid' } as SearchParams)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    search: (params: StreamSearchParams): AsyncIterable<SearchResult<PathogenCountyMetadata>> =>
      this.client.stream.search<PathogenCountyMetadata>('pathogenCounty', params),
    query: (params: StreamQueryParams): AsyncIterable<PathogenCountyMetadata> =>
      this.client.stream.query<PathogenCountyMetadata>('pathogenCounty', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<PathogenCountyMetadata>> =>
      this.client.stream.subscribe<PathogenCountyMetadata>('pathogenCounty', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<PathogenCountyMetadata> {
    return this.client.observe<PathogenCountyMetadata>('pathogenCounty', recordId)
  }

  /** Named feeds. `beam.pathogenCounty.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    recentlyDetected: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<PathogenCountyMetadata>> => this.client.feed<PathogenCountyMetadata>('pathogenCounty', 'recentlyDetected', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<PathogenCountyMetadata>> => this.client.feedNext<PathogenCountyMetadata>('pathogenCounty', 'recentlyDetected', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('pathogenCounty', 'recentlyDetected', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<PathogenCountyMetadata>> => this.client.explainFeed<PathogenCountyMetadata>('pathogenCounty', 'recentlyDetected', params),
      },
    ),
  }

  /** Named analyses. `beam.pathogenCounty.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('pathogenCounty'),
    presenceByPathogen: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "counties": number }>> => this.client.analyze<{ "pathogenId": number }, { "counties": number }>('pathogenCounty', 'presenceByPathogen', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "counties": number }>> => this.client.analyzeNext<{ "pathogenId": number }, { "counties": number }>('pathogenCounty', 'presenceByPathogen', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "pathogenId": number }, { "counties": number }>> => this.client.subscribeAnalyze<{ "pathogenId": number }, { "counties": number }>('pathogenCounty', 'presenceByPathogen', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('pathogenCounty', 'presenceByPathogen', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('pathogenCounty', 'presenceByPathogen', opts),
      },
    ),
    presenceByYear: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number; "year": number }, { "counties": number }>> => this.client.analyze<{ "pathogenId": number; "year": number }, { "counties": number }>('pathogenCounty', 'presenceByYear', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number; "year": number }, { "counties": number }>> => this.client.analyzeNext<{ "pathogenId": number; "year": number }, { "counties": number }>('pathogenCounty', 'presenceByYear', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "pathogenId": number; "year": number }, { "counties": number }>> => this.client.subscribeAnalyze<{ "pathogenId": number; "year": number }, { "counties": number }>('pathogenCounty', 'presenceByYear', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('pathogenCounty', 'presenceByYear', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('pathogenCounty', 'presenceByYear', opts),
      },
    ),
  }
}

export class DiseaseMonthLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof DiseaseMonthMetadata = keyof DiseaseMonthMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<DiseaseMonthMetadata, K>>> {
    return this.client.query<Pick<DiseaseMonthMetadata, K>>('diseaseMonth', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('diseaseMonth', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<DiseaseMonthMetadata> =>
      this.client.stream.query<DiseaseMonthMetadata>('diseaseMonth', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<DiseaseMonthMetadata>> =>
      this.client.stream.subscribe<DiseaseMonthMetadata>('diseaseMonth', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<DiseaseMonthMetadata> {
    return this.client.observe<DiseaseMonthMetadata>('diseaseMonth', recordId)
  }

  /** Named feeds. `beam.diseaseMonth.feed.<name>(params)` returns one page; .subscribe/.explain are on the same handle. */
  readonly feed = {
    latest: Object.assign(
      (params?: FeedRequest): Promise<FeedPage<DiseaseMonthMetadata>> => this.client.feed<DiseaseMonthMetadata>('diseaseMonth', 'latest', params),
      {
        next: (params?: FeedRequest): Promise<FeedPage<DiseaseMonthMetadata>> => this.client.feedNext<DiseaseMonthMetadata>('diseaseMonth', 'latest', params),
        subscribe: (params?: { context?: FeedContext }): AsyncIterable<FeedTickEvent> => this.client.subscribeFeed('diseaseMonth', 'latest', params),
        explain: (params: { recordId: string; context?: FeedContext }): Promise<FeedExplanation<DiseaseMonthMetadata>> => this.client.explainFeed<DiseaseMonthMetadata>('diseaseMonth', 'latest', params),
      },
    ),
  }

  /** Named analyses. `beam.diseaseMonth.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('diseaseMonth'),
    seasonality: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>> => this.client.analyze<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>('diseaseMonth', 'seasonality', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>> => this.client.analyzeNext<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>('diseaseMonth', 'seasonality', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>> => this.client.subscribeAnalyze<{ "month": number; "diseaseId": number }, { "total": number; "avg": number }>('diseaseMonth', 'seasonality', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseaseMonth', 'seasonality', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseaseMonth', 'seasonality', opts),
      },
    ),
  }
}

export class TickDiseasesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TickDiseasesMetadata = keyof TickDiseasesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TickDiseasesMetadata, K>>> {
    return this.client.query<Pick<TickDiseasesMetadata, K>>('tickDiseases', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('tickDiseases', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<TickDiseasesMetadata> =>
      this.client.stream.query<TickDiseasesMetadata>('tickDiseases', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TickDiseasesMetadata>> =>
      this.client.stream.subscribe<TickDiseasesMetadata>('tickDiseases', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TickDiseasesMetadata> {
    return this.client.observe<TickDiseasesMetadata>('tickDiseases', recordId)
  }

  /** Named analyses. `beam.tickDiseases.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('tickDiseases'),
    diseasesPerTick: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "count": number }>> => this.client.analyze<{ "tickId": number }, { "count": number }>('tickDiseases', 'diseasesPerTick', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "count": number }>> => this.client.analyzeNext<{ "tickId": number }, { "count": number }>('tickDiseases', 'diseasesPerTick', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "tickId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "tickId": number }, { "count": number }>('tickDiseases', 'diseasesPerTick', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickDiseases', 'diseasesPerTick', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickDiseases', 'diseasesPerTick', opts),
      },
    ),
    ticksPerDisease: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number }, { "count": number }>> => this.client.analyze<{ "diseaseId": number }, { "count": number }>('tickDiseases', 'ticksPerDisease', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number }, { "count": number }>> => this.client.analyzeNext<{ "diseaseId": number }, { "count": number }>('tickDiseases', 'ticksPerDisease', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "diseaseId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "diseaseId": number }, { "count": number }>('tickDiseases', 'ticksPerDisease', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickDiseases', 'ticksPerDisease', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickDiseases', 'ticksPerDisease', opts),
      },
    ),
  }
}

export class TickPathogensLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TickPathogensMetadata = keyof TickPathogensMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TickPathogensMetadata, K>>> {
    return this.client.query<Pick<TickPathogensMetadata, K>>('tickPathogens', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('tickPathogens', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<TickPathogensMetadata> =>
      this.client.stream.query<TickPathogensMetadata>('tickPathogens', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TickPathogensMetadata>> =>
      this.client.stream.subscribe<TickPathogensMetadata>('tickPathogens', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TickPathogensMetadata> {
    return this.client.observe<TickPathogensMetadata>('tickPathogens', recordId)
  }

  /** Named analyses. `beam.tickPathogens.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('tickPathogens'),
    pathogensPerTick: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "count": number }>> => this.client.analyze<{ "tickId": number }, { "count": number }>('tickPathogens', 'pathogensPerTick', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "tickId": number }, { "count": number }>> => this.client.analyzeNext<{ "tickId": number }, { "count": number }>('tickPathogens', 'pathogensPerTick', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "tickId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "tickId": number }, { "count": number }>('tickPathogens', 'pathogensPerTick', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickPathogens', 'pathogensPerTick', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickPathogens', 'pathogensPerTick', opts),
      },
    ),
    ticksPerPathogen: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "count": number }>> => this.client.analyze<{ "pathogenId": number }, { "count": number }>('tickPathogens', 'ticksPerPathogen', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "count": number }>> => this.client.analyzeNext<{ "pathogenId": number }, { "count": number }>('tickPathogens', 'ticksPerPathogen', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "pathogenId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "pathogenId": number }, { "count": number }>('tickPathogens', 'ticksPerPathogen', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('tickPathogens', 'ticksPerPathogen', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('tickPathogens', 'ticksPerPathogen', opts),
      },
    ),
  }
}

export class DiseasePathogensLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof DiseasePathogensMetadata = keyof DiseasePathogensMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<DiseasePathogensMetadata, K>>> {
    return this.client.query<Pick<DiseasePathogensMetadata, K>>('diseasePathogens', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('diseasePathogens', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<DiseasePathogensMetadata> =>
      this.client.stream.query<DiseasePathogensMetadata>('diseasePathogens', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<DiseasePathogensMetadata>> =>
      this.client.stream.subscribe<DiseasePathogensMetadata>('diseasePathogens', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<DiseasePathogensMetadata> {
    return this.client.observe<DiseasePathogensMetadata>('diseasePathogens', recordId)
  }

  /** Named analyses. `beam.diseasePathogens.analyze.<name>(input)` runs one shot; .subscribe/.explain/.rows are on the same handle. */
  readonly analyze = {
    list: (): Promise<AnalyzeListResponse> => this.client.listAnalyses('diseasePathogens'),
    pathogensPerDisease: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number }, { "count": number }>> => this.client.analyze<{ "diseaseId": number }, { "count": number }>('diseasePathogens', 'pathogensPerDisease', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "diseaseId": number }, { "count": number }>> => this.client.analyzeNext<{ "diseaseId": number }, { "count": number }>('diseasePathogens', 'pathogensPerDisease', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "diseaseId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "diseaseId": number }, { "count": number }>('diseasePathogens', 'pathogensPerDisease', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseasePathogens', 'pathogensPerDisease', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseasePathogens', 'pathogensPerDisease', opts),
      },
    ),
    diseasesPerPathogen: Object.assign(
      (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "count": number }>> => this.client.analyze<{ "pathogenId": number }, { "count": number }>('diseasePathogens', 'diseasesPerPathogen', input, callOpts),
      {
        next: (input?: { where?: Record<string, unknown> }, callOpts?: { cache?: AnalyzeCache | null; swr?: boolean; directive?: 'no-cache' | 'force' }): Promise<AnalyzeResult<{ "pathogenId": number }, { "count": number }>> => this.client.analyzeNext<{ "pathogenId": number }, { "count": number }>('diseasePathogens', 'diseasesPerPathogen', input, callOpts),
        subscribe: (params?: { input?: { where?: Record<string, unknown> }; onSubscribe?: 'fresh' | 'silent' }): AsyncIterable<AnalyzeStreamEvent<{ "pathogenId": number }, { "count": number }>> => this.client.subscribeAnalyze<{ "pathogenId": number }, { "count": number }>('diseasePathogens', 'diseasesPerPathogen', params),
        explain: (input?: { where?: Record<string, unknown> }): Promise<AnalyzeExplanation> => this.client.explainAnalyze('diseasePathogens', 'diseasesPerPathogen', input),
        rows: (opts: { bucketKey: string; cursor?: string; limit?: number }): Promise<AnalyzeRowsPage> => this.client.analyzeRows('diseasePathogens', 'diseasesPerPathogen', opts),
      },
    ),
  }
}

export class TickRemovalTechniquesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof TickRemovalTechniquesMetadata = keyof TickRemovalTechniquesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<TickRemovalTechniquesMetadata, K>>> {
    return this.client.query<Pick<TickRemovalTechniquesMetadata, K>>('tickRemovalTechniques', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('tickRemovalTechniques', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<TickRemovalTechniquesMetadata> =>
      this.client.stream.query<TickRemovalTechniquesMetadata>('tickRemovalTechniques', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<TickRemovalTechniquesMetadata>> =>
      this.client.stream.subscribe<TickRemovalTechniquesMetadata>('tickRemovalTechniques', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<TickRemovalTechniquesMetadata> {
    return this.client.observe<TickRemovalTechniquesMetadata>('tickRemovalTechniques', recordId)
  }
}

export class WildFactTicksLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof WildFactTicksMetadata = keyof WildFactTicksMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<WildFactTicksMetadata, K>>> {
    return this.client.query<Pick<WildFactTicksMetadata, K>>('wildFactTicks', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('wildFactTicks', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<WildFactTicksMetadata> =>
      this.client.stream.query<WildFactTicksMetadata>('wildFactTicks', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<WildFactTicksMetadata>> =>
      this.client.stream.subscribe<WildFactTicksMetadata>('wildFactTicks', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<WildFactTicksMetadata> {
    return this.client.observe<WildFactTicksMetadata>('wildFactTicks', recordId)
  }
}

export class WildFactDiseasesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof WildFactDiseasesMetadata = keyof WildFactDiseasesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<WildFactDiseasesMetadata, K>>> {
    return this.client.query<Pick<WildFactDiseasesMetadata, K>>('wildFactDiseases', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('wildFactDiseases', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<WildFactDiseasesMetadata> =>
      this.client.stream.query<WildFactDiseasesMetadata>('wildFactDiseases', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<WildFactDiseasesMetadata>> =>
      this.client.stream.subscribe<WildFactDiseasesMetadata>('wildFactDiseases', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<WildFactDiseasesMetadata> {
    return this.client.observe<WildFactDiseasesMetadata>('wildFactDiseases', recordId)
  }
}

export class WildFactRemovalTechniquesLens {
  constructor(private readonly client: BeamClient) {}

  async query<K extends keyof WildFactRemovalTechniquesMetadata = keyof WildFactRemovalTechniquesMetadata>(
    params?: Omit<QueryParams, 'fields'> & { fields?: readonly K[] },
  ): Promise<QueryResponse<Pick<WildFactRemovalTechniquesMetadata, K>>> {
    return this.client.query<Pick<WildFactRemovalTechniquesMetadata, K>>('wildFactRemovalTechniques', params as QueryParams)
  }

  async count(params?: CountParams): Promise<CountResponse> {
    return this.client.count('wildFactRemovalTechniques', params)
  }

  /** Streaming surface — chunked results, live tail. */
  readonly stream = {
    query: (params: StreamQueryParams): AsyncIterable<WildFactRemovalTechniquesMetadata> =>
      this.client.stream.query<WildFactRemovalTechniquesMetadata>('wildFactRemovalTechniques', params),
    subscribe: (params?: SubscribeParams): AsyncIterable<StreamEvent<WildFactRemovalTechniquesMetadata>> =>
      this.client.stream.subscribe<WildFactRemovalTechniquesMetadata>('wildFactRemovalTechniques', params),
  }

  /** Observe one record — first yield is the current state, subsequent yields are per-subscription deltas. */
  observe(recordId: string): AsyncIterable<WildFactRemovalTechniquesMetadata> {
    return this.client.observe<WildFactRemovalTechniquesMetadata>('wildFactRemovalTechniques', recordId)
  }
}
